import { useEffect, useState } from "react";
import * as yup from 'yup';

// Hook personnalisé pour la validation
const useValidation = <T extends {}>(
    data: T, 
    schema: yup.ObjectSchema<T>
) => {
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        const validateData = async () => {
            try {
                await schema.validate(data, { abortEarly: false });
                setErrors({});
                setIsValid(true);
            }
            catch (err) {
                if (err instanceof yup.ValidationError) {
                    const errorMessages = err.inner.reduce((acc, curr) => {
                    if (curr.path) {
                        acc[curr.path] = curr.message;
                    }
                    return acc;
                    }, {} as { [key: string]: string });
                    
                    setErrors(errorMessages);
                    setIsValid(false);
                }
            }
        };

        validateData();
    }, [data, schema]);

    return { errors, isValid };
};

export default useValidation;